import { ActionStatus } from '../../../common/constants/action-status';
import { AddProductToWishListRequest } from '../interfaces/wish-list-update-product.interface';
import { StoreState } from '../../../store/store.interface';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAddProductToWishlistsApiCallMagento } from '../apis/wish-list-add-product.api';

export const addProductToWishList = createAsyncThunk(
  'wishList/addProduct',
  async (request: AddProductToWishListRequest) => {
    return await getAddProductToWishlistsApiCallMagento(request);
  }, {
    condition: ((_arg, {getState}) => {
      const state = getState() as StoreState;
      return state.wishListState.addProductToWishList.status != ActionStatus.loading;
    })
  }
);
